import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-states',
  templateUrl: './states.component.html',
  styleUrls: ['./states.component.scss']
})
export class StatesComponent {


  @Input() stateName: string;

  public stateMap = {
    save: {
      icon: 'far fa-save',
      text: 'Salvando'
    },
    searching: {
      icon: 'fas fa-search',
      text: 'Procurando'
    }
  };

  get state() {
    return this.stateMap[this.stateName];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/states/states.component.ts